import { render } from "./ProLaboreForm.vue?vue&type=template&id=ea2a348c&scoped=true"
import script from "./ProLaboreForm.vue?vue&type=script&lang=js"
export * from "./ProLaboreForm.vue?vue&type=script&lang=js"

import "./ProLaboreForm.vue?vue&type=style&index=0&id=ea2a348c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2a348c"]])

export default __exports__